// src/constants/expenseCategories.js
// ============================================================================
// FRONTEND MIRROR of functions/constants/expenseCategories.js
//
// The web-landing bundle can't reach into functions/, so these enums live in
// both places. Keep them in sync — the backend's onCall validators are the
// authoritative source; the frontend uses these for dropdown options and
// display labels in the Add/Edit modal and the Operating Expenses section
// on FinancialsScreen.
//
// For aggregated views (Burn by Category / Vendor), prefer the enriched
// fields returned by adminGetExpenseAggregations (which inlines displayName +
// color + icon) — these constants are mostly a fallback for the rare case
// where a vendor/category id appears that the backend response didn't enrich.
// ============================================================================

export const EXPENSE_VENDORS = {
  gcp:        { id: 'gcp',        displayName: 'Google Cloud Platform', shortName: 'GCP',        defaultCategory: 'infrastructure' },
  mux:        { id: 'mux',        displayName: 'Mux',                   shortName: 'Mux',        defaultCategory: 'streaming' },
  mediamtx:   { id: 'mediamtx',   displayName: 'MediaMTX',              shortName: 'MediaMTX',   defaultCategory: 'streaming' },
  anthropic:  { id: 'anthropic',  displayName: 'Anthropic (Claude)',    shortName: 'Anthropic',  defaultCategory: 'ai_apis' },
  openai:     { id: 'openai',     displayName: 'OpenAI',                shortName: 'OpenAI',     defaultCategory: 'ai_apis' },
  gemini:     { id: 'gemini',     displayName: 'Google Gemini',         shortName: 'Gemini',     defaultCategory: 'ai_apis' },
  aws:        { id: 'aws',        displayName: 'AWS',                   shortName: 'AWS',        defaultCategory: 'ai_apis' },
  twelvelabs: { id: 'twelvelabs', displayName: 'TwelveLabs',            shortName: 'TwelveLabs', defaultCategory: 'ai_apis' },
  sendgrid:   { id: 'sendgrid',   displayName: 'SendGrid',              shortName: 'SendGrid',   defaultCategory: 'email' },
  persona:    { id: 'persona',    displayName: 'Persona',               shortName: 'Persona',    defaultCategory: 'kyc' },
  domain:     { id: 'domain',     displayName: 'Domain Registration',   shortName: 'Domain',     defaultCategory: 'misc' },
  other:      { id: 'other',      displayName: 'Other',                 shortName: 'Other',      defaultCategory: 'misc' },
};

export const EXPENSE_CATEGORIES = {
  infrastructure: { id: 'infrastructure', displayName: 'Infrastructure',         color: '#3B82F6', icon: 'server-outline' },
  ai_apis:        { id: 'ai_apis',        displayName: 'AI APIs',                color: '#8B5CF6', icon: 'sparkles-outline' },
  streaming:      { id: 'streaming',      displayName: 'Streaming',              color: '#EC4899', icon: 'videocam-outline' },
  payments:       { id: 'payments',       displayName: 'Payment Processing',     color: '#F59E0B', icon: 'card-outline' },
  kyc:            { id: 'kyc',            displayName: 'KYC / Identity',         color: '#10B981', icon: 'shield-checkmark-outline' },
  email:          { id: 'email',          displayName: 'Email & Notifications',  color: '#06B6D4', icon: 'mail-outline' },
  misc:           { id: 'misc',           displayName: 'Miscellaneous',          color: '#6B7280', icon: 'ellipsis-horizontal-outline' },
};

export const PAID_FROM_ACCOUNTS = {
  mercury_operating: { id: 'mercury_operating', displayName: 'Mercury Operating' },
  stripe_balance:    { id: 'stripe_balance',    displayName: 'Stripe Balance' },
  credit_card:       { id: 'credit_card',       displayName: 'Credit Card' },
  pending:           { id: 'pending',           displayName: 'Not Yet Paid' },
};

export const VENDOR_OPTIONS = Object.values(EXPENSE_VENDORS);
export const CATEGORY_OPTIONS = Object.values(EXPENSE_CATEGORIES);
export const PAID_FROM_OPTIONS = Object.values(PAID_FROM_ACCOUNTS);

// Same constant the backend enforces — duplicated for the FinancialsScreen banner.
export const STRIPE_ATLAS_FEE_WAIVER_EXPIRES = '2027-01-23';
